// extracted by mini-css-extract-plugin
module.exports = {"toggleGroup":"CollectionToggle_toggleGroup__5yDwY","collectionToggle":"CollectionToggle_collectionToggle__nxrGH"};